import React from "react";
import { Col, Input, Row } from "reactstrap";
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown";
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton";

const PaymentSchedule = () => {
  const leftColData = [
    "Sales are recorded at the end of each day",
    "Payments are processed every Monday and Thursday",
    "Funds are disbursed within 2 business days after processing",
  ];

  return (
    <section>
      <Row className="g-0">
        <Col xl={6} className="pe-xl-3">
          <div className="d-flex flex-column h-100">
            <div className="fw-semibold fs-5 my-2">
              Understanding Your Payment Cycle
            </div>
            <div className="bg-white p-2 h-100">
              <div className="border border-subtle-primary p-3 h-100">
                <ul className="my-0">
                  {leftColData.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Col>
        <Col xl={6} className="ps-xl-3">
          <div className="d-flex flex-column h-100">
            <div className="fw-semibold fs-5 my-2">Key Dates and Deadlines</div>
            <div className="bg-white p-2 h-100">
              <div className="border border-subtle-primary p-3 h-100">
                <Row className="g-0 row-gap-1">
                  <Col lg={6}>
                    <div className="fw-medium pe-3">Sales Period Ends:</div>
                  </Col>
                  <Col lg={6}>
                    <div>Every Sunday and Wednesday by 23:59</div>
                  </Col>
                </Row>
                <Row className="g-0 row-gap-1">
                  <Col lg={6}>
                    <div className="fw-medium pe-3">Processing Begins:</div>
                  </Col>
                  <Col lg={6}>
                    <div>The following day (Monday and Thursday)</div>
                  </Col>
                </Row>
                <Row className="g-0 row-gap-1">
                  <Col lg={6}>
                    <div className="fw-medium pe-3">Expected Payment Date:</div>
                  </Col>
                  <Col lg={6}>
                    <div>Within 48 hours after processing</div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="g-0">
        <Col>
          <div className="fw-semibold fs-5 my-2">
            Customize Your Payment Schedule
          </div>
          <div className="bg-white p-2">
            <div className="border border-subtle-primary p-3">
              <Row className="g-0">
                <Col xl={9} xxl={6}>
                  <div className="d-flex flex-column gap-2">
                    <Row className="g-0 row-gap-1">
                      <Col lg={6} className="d-flex align-items-center pe-2">
                        <div>Choose Your Payment Frequency:</div>
                      </Col>
                      <Col lg={6}>
                        <div className="border border-secondary rounded p-1">
                          <CustomDropdown
                            title={"Choose from dropdown"}
                            muted
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="g-0 row-gap-1">
                      <Col lg={6} className="d-flex align-items-center pe-2">
                        <div>Set Your Minimum Payment Threshold:</div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <Input placeholder="$" />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="g-0">
        <div className="fw-semibold fs-5 my-2">Preferred Payment Method</div>
        <Col xl="6">
          <div className="bg-white p-2">
            <div className="border border-subtle-primary p-3">
              <Row className="g-0 align-items-center justify-content-between gap-4 row-gap-2">
                <Col xs={"auto"} className="d-flex align-items-center">
                  <div>HBL Bank (***1234)</div>
                </Col>
                <Col xs={"auto"}>
                  <PrimaryButton name={"Update Method"} />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default PaymentSchedule;